import { Container, Row, Col, Card, Image, Button } from 'react-bootstrap';
import PageHero from '../components/PageHero';

const sponsors = [
  {
    name: 'Gesellschaft für Aerosolforschung',
    country: 'Germany',
    logo: 'sponsors/sponsors_gaef.webp',
    url: 'https://www.info.gaef.de/',
    description:
      'GAeF is a scientific association dedicated to aerosol research and the exchange of knowledge across the aerosol science community.',
  },
  {
    name: 'University of Nova Gorica',
    country: 'Slovenia',
    logo: 'sponsors/sponsors_ung.webp',
    url: 'https://ung.si/en/',
    description:
      'The University of Nova Gorica is a research-oriented university with strong involvement in atmospheric science, environmental research and international collaboration.',
  },
  {
    name: 'National Institute of Chemistry',
    country: 'Slovenia',
    logo: 'sponsors/sponsors_ki.webp',
    url: 'https://www.ki.si/en/',
    description:
      'The National Institute of Chemistry is one of Slovenia’s leading research institutions, supporting scientific excellence across chemistry, materials and environmental research.',
  },
  {
    name: 'Jožef Stefan Institute',
    country: 'Slovenia',
    logo: 'sponsors/sponsors_jsi.webp',
    url: 'https://www.ijs.si/ijsw/V001/JSI',
    description:
      'The Jožef Stefan Institute is Slovenia’s largest research institute, covering a broad range of scientific and technological disciplines.',
  },
  {
    name: 'Aerosol Magee Scientific',
    country: 'Slovenia',
    logo: 'sponsors/sponsors_aerosol.webp',
    url: 'https://aerosolmageesci.com/',
    description:
      'Aerosol Magee Scientific develops and provides instruments and expertise for aerosol, black carbon and atmospheric measurements.',
  },
  {
    name: 'Aethlabs',
    country: 'USA',
    logo: 'sponsors/sponsors_aethlabs.webp',
    url: 'https://aethlabs.com/',
    description:
      'Aethlabs develops portable and real-time air quality monitoring instruments for aerosol and black carbon measurements.',
  },
];

export default function Sponsors() {
  return (
    <div className="page-content">
      <PageHero
        eyebrow="Sponsors"
        title="Our sponsors"
        intro="EAC2027 is supported by institutions and organizations committed to aerosol science, research collaboration and scientific exchange."
      />

      <main className="info-page pt-5 pb-5">
        <Container className="pt-5">
          <Row className="justify-content-center">
            <Col lg={10} xl={9}>
              <section className="info-section">
                <h2 className="h1">EAC2027 Sponsors and Organizers</h2>
                <p>
                  EAC2027 is made possible through the support of scientific associations, research institutions and organizations that contribute to the advancement of aerosol science and international collaboration.
                </p>
              </section>
            </Col>
          </Row>  

              <section className="info-section">
                

                <Row className="g-4  mb-5">
                  {sponsors.map((sponsor) => (
                    <Col md={6} lg={3} key={sponsor.name}>
                      <Card className="sponsor-card h-100">
                        <Card.Body>
                          <div className="sponsor-logo">
                            <Image src={sponsor.logo} alt={sponsor.name} fluid />
                          </div>

                          <h3>{sponsor.name}</h3>

                          {sponsor.country && (
                            <p className="sponsor-country">
                              {sponsor.country}
                            </p>
                          )}

                          <p>{sponsor.description}</p>

                          <Button
                            as="a"
                            href={sponsor.url}
                            target="_blank"
                            rel="noreferrer"
                            variant="outline-eac"
                            size="sm"
                            className="mt-auto"
                          >
                            Visit website
                          </Button>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </section>
            
          
        </Container>
      </main>
    </div>
  );
}